import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/styles.module.scss';
import UploadProgressBar from '../UploadProgressBar';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const UploadTracker = ({ uploading, progress, openDropzone }) => {
  const content = uploading ? (
    <div className={styles.progress}>
      <div className={styles.progressText}>
        <span className={styles.uploading}>{StringConstantsMixin.strings.UPLOADING}</span>
        {progress}%
      </div>
      <UploadProgressBar progress={progress} />
    </div>
  ) : (
    // using dangerouslySetInnerHTML because we have styling on text that needs to be translated
    <div className={styles.uploadContent} onClick={openDropzone}>
      <div className={styles.uploadHeader} dangerouslySetInnerHTML={StringConstantsMixin.strings.CONTRIBUTE.DRAG_PHOTOS_HERE} />
      <div className={styles.uploadSubtext}>{StringConstantsMixin.strings.CONTRIBUTE.PNG_JPG_JPEG}</div>
    </div>
  );

  return <div className={styles.container}>{content}</div>;
};

UploadTracker.propTypes = {
  uploading: PropTypes.bool,
  progress: PropTypes.number,
  openDropzone: PropTypes.func
};

UploadTracker.defaultProps = {
  uploading: false,
  progress: 0,
  openDropzone: () => {}
};

export default UploadTracker;
